import React from "react";
import { useNavigate } from "react-router-dom";
import "./CTASection.css";

const CTASection = ({ useContainer = true, title = "Ready to Transform Your Lending Operations?", buttonText = "Schedule a Demo" }) => {
  const navigate = useNavigate();

  const content = (
    <div className="cta-section">
      <h3 className="cta-title">{title}</h3>
      <button className="cta-button" onClick={() => navigate("/book-now")}>
        {buttonText}
      </button>
    </div>
  );

  return useContainer ? <div className="cta-wrapper">{content}</div> : content;
};

export default CTASection;